import Remove from 'assets/icons/remove';
import { IconButton } from '@mui/material';

const DeleteIconButton = ({ onClick, disabled = false, sx = {} }) => {
	return (
		<IconButton sx={{ padding: 0, cursor: 'pointer', width: '34px', height: '34px', ...sx }} onClick={onClick} disabled={disabled}>
			<Remove color="#ff4d4f" width="20px" height="20px" />
		</IconButton>
	);
};

export default DeleteIconButton;
